// Terms at sign-up (docs/plans/terms.md). What proves agreement is the server's record
// (profiles.terms_version / terms_accepted_at); the app only shows the Terms and asks.

/**
 * The current Terms: the "Last updated" date on sanogodam.com/terms. Must equal the newest
 * migration's `terms_version()` (apps/web/src/terms-version.test.ts checks the three agree).
 */
export const TERMS_VERSION = '2026-09-28'

export const TERMS_URL = 'https://sanogodam.com/terms'
export const PRIVACY_URL = 'https://sanogodam.com/privacy'

/** What changed in the current Terms, in plain lines, for the "updated" prompt. */
export const TERMS_CHANGES: string[] = []

/** Whether to ask: never accepted any Terms ('first'), accepted older ones ('updated'), or not. */
export function termsAsk(
  accepted: string | null | undefined,
  current: string,
): 'first' | 'updated' | null {
  if (accepted === current) return null
  return accepted ? 'updated' : 'first'
}
